import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function AGBPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-754">
      <Navbar data-id="element-755" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto w-full" data-id="element-756">
        <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-10 tracking-tight" data-id="element-757">
          Allgemeine Geschäftsbedingungen
        </h1>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed" data-id="element-758">
          <section data-id="element-759">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-760">
              1. Geltungsbereich
            </h2>
            <p data-id="element-761">
              Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle
              Buchungen von Fortbildungskursen, Seminaren und Veranstaltungen
              der 2N Kurse GbR Dres. Schwenk, Striegel, Herzog (nachfolgend
              „Veranstalter" genannt). Mit der Anmeldung zu einer Veranstaltung
              erkennt der Teilnehmer diese AGB an.
            </p>
          </section>

          <section data-id="element-762">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-763">
              2. Anmeldung und Vertragsschluss
            </h2>
            <p data-id="element-764">
              Die Anmeldung zu einer Veranstaltung erfolgt über das
              Online-Buchungsformular auf unserer Website, per E-Mail oder
              telefonisch. Mit der Anmeldung gibt der Teilnehmer ein
              verbindliches Angebot zum Abschluss eines Teilnahmevertrages ab.
            </p>
            <p className="mt-4" data-id="element-765">
              Der Vertrag kommt zustande, wenn der Veranstalter die Anmeldung
              durch eine Buchungsbestätigung per E-Mail annimmt. Die
              Buchungsbestätigung wird in der Regel innerhalb von 5 Werktagen
              nach Eingang der Anmeldung versendet.
            </p>
          </section>

          <section data-id="element-766">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-767">
              3. Teilnahmegebühren und Zahlung
            </h2>
            <p data-id="element-768">
              Die Teilnahmegebühren ergeben sich aus der jeweils aktuellen
              Kursbeschreibung auf unserer Website. Alle Preise verstehen sich
              zuzüglich der gesetzlichen Mehrwertsteuer (derzeit 19%).
            </p>
            <p className="mt-4" data-id="element-769">
              Die Rechnung wird nach Buchungseingang per E-Mail versendet. Die
              Zahlung ist innerhalb von 14 Tagen nach Rechnungsstellung fällig.
              Bei Buchungen, die weniger als 14 Tage vor Veranstaltungsbeginn
              erfolgen, ist die Zahlung sofort fällig.
            </p>
            <p className="mt-4" data-id="element-770">
              In den Kursgebühren enthalten sind, sofern nicht anders angegeben:
              Kursmaterialien, Verpflegung während der Veranstaltung sowie die
              Teilnahme an der Abendveranstaltung.
            </p>
          </section>

          <section data-id="element-771">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-772">
              4. Stornierung und Rücktritt
            </h2>
            <p data-id="element-773">
              Der Teilnehmer kann seine Anmeldung schriftlich (per E-Mail an
              info@2n-fortbildung.de) stornieren. Es gelten folgende
              Stornierungsbedingungen:
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2" data-id="element-774">
              <li data-id="element-775">
                Bis 8 Wochen vor Veranstaltungsbeginn: kostenfreie Stornierung
              </li>
              <li data-id="element-776">
                Bis 4 Wochen vor Veranstaltungsbeginn: 50% der Teilnahmegebühr
              </li>
              <li data-id="element-777">
                Weniger als 4 Wochen vor Veranstaltungsbeginn: 100% der
                Teilnahmegebühr
              </li>
            </ul>
            <p className="mt-4" data-id="element-778">
              Dem Teilnehmer steht es frei, einen Ersatzteilnehmer zu benennen.
              Die Benennung eines Ersatzteilnehmers ist bis zum
              Veranstaltungsbeginn möglich und muss dem Veranstalter schriftlich
              mitgeteilt werden.
            </p>
          </section>

          <section data-id="element-779">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-780">
              5. Absage und Änderungen durch den Veranstalter
            </h2>
            <p data-id="element-781">
              Der Veranstalter behält sich das Recht vor, Veranstaltungen bei zu
              geringer Teilnehmerzahl oder aus anderen wichtigen Gründen (z.B.
              höhere Gewalt, Erkrankung des Referenten) abzusagen oder zu
              verschieben. In diesem Fall werden bereits gezahlte
              Teilnahmegebühren vollständig erstattet.
            </p>
            <p className="mt-4" data-id="element-782">
              Weitergehende Ansprüche des Teilnehmers, insbesondere auf Ersatz
              von Reise- und Übernachtungskosten, sind ausgeschlossen, es sei
              denn, der Veranstalter hat die Absage vorsätzlich oder grob
              fahrlässig verursacht.
            </p>
          </section>

          <section data-id="element-783">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-784">
              6. Fortbildungspunkte und Zertifikate
            </h2>
            <p data-id="element-785">
              Die Veranstaltungen sind bei der zuständigen Zahnärztekammer zur
              Vergabe von Fortbildungspunkten angemeldet. Die angegebenen
              Fortbildungspunkte entsprechen den zum Zeitpunkt der
              Veröffentlichung gültigen Angaben. Der Veranstalter übernimmt
              keine Gewähr für die Anerkennung der Fortbildungspunkte durch die
              jeweilige Kammer des Teilnehmers.
            </p>
            <p className="mt-4" data-id="element-786">
              Teilnahmezertifikate werden nach vollständiger Teilnahme an der
              Veranstaltung und nach Zahlungseingang ausgestellt.
            </p>
          </section>

          <section data-id="element-787">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-788">
              7. Haftung
            </h2>
            <p data-id="element-789">
              Der Veranstalter haftet für Schäden nur bei Vorsatz und grober
              Fahrlässigkeit. Die Haftung für leichte Fahrlässigkeit ist
              ausgeschlossen, soweit keine wesentlichen Vertragspflichten
              verletzt werden. Die Haftung ist in diesen Fällen auf den
              vorhersehbaren, vertragstypischen Schaden begrenzt.
            </p>
            <p className="mt-4" data-id="element-790">
              Die in den Veranstaltungen vermittelten Inhalte stellen keine
              individuelle Beratung dar. Die Anwendung der erlernten Techniken
              und Methoden erfolgt in eigener Verantwortung des Teilnehmers.
            </p>
          </section>

          <section data-id="element-791">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-792">
              8. Urheberrecht
            </h2>
            <p data-id="element-793">
              Sämtliche Kursunterlagen, Präsentationen und Materialien sind
              urheberrechtlich geschützt. Die Vervielfältigung, Verbreitung oder
              öffentliche Zugänglichmachung – auch auszugsweise – bedarf der
              vorherigen schriftlichen Zustimmung des Veranstalters.
            </p>
            <p className="mt-4" data-id="element-794">
              Das Anfertigen von Foto-, Video- oder Tonaufnahmen während der
              Veranstaltungen ist nur mit ausdrücklicher Genehmigung des
              Veranstalters gestattet.
            </p>
          </section>

          <section data-id="element-795">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-796">
              9. Datenschutz
            </h2>
            <p data-id="element-797">
              Die Erhebung und Verarbeitung personenbezogener Daten erfolgt
              gemäß unserer{' '}
              <a href="/datenschutz" className="text-[#3b7780] font-bold underline hover:text-[#59d0d4]" data-id="element-798">
                Datenschutzerklärung
              </a>
              . Mit der Anmeldung erklärt sich der Teilnehmer mit der
              Verarbeitung seiner Daten zum Zwecke der
              Veranstaltungsorganisation einverstanden.
            </p>
          </section>

          <section data-id="element-799">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-800">
              10. Schlussbestimmungen
            </h2>
            <p data-id="element-801">
              Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand
              ist Nürnberg, sofern der Teilnehmer Kaufmann, juristische Person
              des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen
              ist.
            </p>
            <p className="mt-4" data-id="element-802">
              Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder
              werden, so bleibt die Wirksamkeit der übrigen Bestimmungen davon
              unberührt.
            </p>
          </section>

          <section data-id="element-803">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-804">
              Veranstalter
            </h2>
            <p className="bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-805">
              2N Kurse GbR Dres. Schwenk, Striegel, Herzog
              <br data-id="element-806" />
              Ludwigsplatz 1a
              <br data-id="element-807" />
              90403 Nürnberg
              <br data-id="element-808" />
              Telefon: 0911 – 56836360
              <br data-id="element-809" />
              E-Mail: info@2n-fortbildung.de
            </p>
          </section>
        </div>
      </main>
      <Footer data-id="element-810" />
    </div>;
}